(function () {
  var MAP = {
    'Brun|37':'41461869346879', 'Brun|38':'41461869379647',
    'Brun|39':'41461869412415', 'Brun|40':'41461869445183',
    'Brun|41':'41461869477951', 'Brun|42':'41461869510719',
    'Noir|37':'41461869543487', 'Noir|38':'41461869576255',
    'Noir|39':'41461869609023', 'Noir|40':'41461869641791',
    'Noir|41':'41461869674559', 'Noir|42':'41461869707327'
  };
  var redirecting = false;

  // Fix bfcache: reseta a flag quando o browser restaura a página do cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      redirecting = false;
    }
  });

  function doCheckoutRedirect(e) {
    // preventDefault + stopImmediatePropagation SEMPRE em primeiro lugar —
    // o clique JAMAIS vaza para o checkout nativo, independente da flag
    e.preventDefault();
    e.stopImmediatePropagation();
    if (redirecting) return;
    redirecting = true;

    // Timeout de segurança: libera a flag se o redirect não ocorrer em 4s
    var safetyTimer = setTimeout(function () { redirecting = false; }, 4000);

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parts = [];
        cart.items.forEach(function (item) {
          var cor = null, tamanho = null;
          if (item.options_with_values) {
            item.options_with_values.forEach(function (o) {
              if (o.name === 'Cor')     cor     = o.value;
              if (o.name === 'Tamanho') tamanho = o.value;
            });
          }
          var key  = (cor && tamanho) ? (cor + '|' + tamanho) : null;
          var dest = key ? MAP[key] : null;
          if (!dest) {
            console.warn('[Hugo] Item não mapeável (ignorado):', item.title, '— key:', key);
          } else {
            parts.push(dest + ':' + item.quantity);
          }
        });

        if (parts.length === 0) {
          console.warn('[Hugo] Nenhum item mapeável no carrinho — checkout bloqueado (Loja A sem gateway).');
          clearTimeout(safetyTimer);
          redirecting = false;
          return;
        }
        clearTimeout(safetyTimer);
        window.location.href = 'https://aventis-mode.shop/cart/' + parts.join(',');
      })
      .catch(function (err) {
        console.warn('[Hugo] Erro ao ler /cart.js — checkout bloqueado:', err);
        clearTimeout(safetyTimer);
        redirecting = false;
      });
  }

  // Click capture — gaveta (#CartDrawer-Checkout) e página /cart (#checkout)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('#CartDrawer-Checkout, #checkout');
    if (!btn || btn.disabled) return;
    doCheckoutRedirect(e);
  }, true);

  // Submit capture — fallback se o form for submetido programaticamente
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || (f.id !== 'CartDrawer-Form' && f.id !== 'cart')) return;
    doCheckoutRedirect(e);
  }, true);

})();
